var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7404_65808",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 8,
    height: 7,
    fill: "#c1c5d6"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4082 1.5H12.2047V7.72928H5.4082V1.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7404_65808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.625 5.25023C11.3145 5.25023 11.0797 5.2035 11.0797 4.893C11.0797 3.64275 10.0635 2.625 8.8132 2.625C8.20495 2.646 7.63495 2.856 7.20445 3.282C6.77395 3.70875 6.53545 4.2765 6.5332 4.88175C6.5332 5.19225 6.3105 5.25023 6 5.25023C5.6895 5.25023 5.4082 5.2035 5.4082 4.893C5.41195 3.97125 5.7682 3.12075 6.41245 2.48325C7.05595 1.845 7.91995 1.52625 8.81545 1.5C10.6837 1.5 12.2047 3.0225 12.2047 4.893C12.2047 5.2035 11.9355 5.25023 11.625 5.25023Z",
    fill: "#c1c5d6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7404_65808",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 16,
    height: 13,
    fill: "#c1c5d6"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 4.85938H16.1248V16.5031H1.5V4.85938Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7404_65808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.256 5.98438C3.8055 5.98438 2.625 7.16337 2.625 8.61312V12.7501C2.625 14.1991 3.8055 15.3781 5.256 15.3781H12.369C13.8195 15.3781 15 14.1991 15 12.7501V8.61312C15 7.16337 13.8195 5.98438 12.369 5.98438H5.256ZM12.369 16.5031H5.256C3.18525 16.5031 1.5 14.8194 1.5 12.7501V8.61312C1.5 6.54312 3.18525 4.85938 5.256 4.85938H12.369C14.4405 4.85938 16.125 6.54312 16.125 8.61312V12.7501C16.125 14.8194 14.4405 16.5031 12.369 16.5031Z",
    fill: "#c1c5d6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.61cf0214d97703ad293b70723bc49f77.svg";
export { ForwardRef as ReactComponent };